module.exports = __webpack_public_path__ + "img/icon-04.5bb3b2c5.png";